// Idempotently injects the YouTube IFrame API script.
//
// The dashboard calls this at mount so the API is (usually) already
// loaded and cached by the time a learner opens their first video --
// shrinking the window where a play tap lands on a not-yet-ready player
// and has to take the deferred (gesture-less, muted) path. The modal
// still calls it too, so it stays self-sufficient for any other entry
// point (deep links straight into ?v=).
const ensureYouTubeApi = () => {
  if (window.YT && window.YT.Player) return;
  const existingScript = document.querySelector(
    'script[src="https://www.youtube.com/iframe_api"]',
  );
  if (existingScript) return;
  const tag = document.createElement("script");
  tag.src = "https://www.youtube.com/iframe_api";
  const firstScriptTag = document.getElementsByTagName("script")[0];
  if (firstScriptTag?.parentNode) {
    firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
  } else {
    document.head.appendChild(tag);
  }
};

export default ensureYouTubeApi;
